import React from 'react';
import { defaultTemplate } from 'core/hoc';
import BasicRadio from 'themes/components/forms/BasicRadio';
import { ButtonGroup, Button } from '@progress/kendo-react-buttons';
import _ from 'lodash';
import { translate } from 'core/utils';

const AddressValidationTemplate = ({
	modalParams: {
		data: {
			onValidateAddressBack,
			onToggleAddress,
			onValidateAddressConfirm,
			useEnteredAddress,
			stateDropdownStore,
			countryDropdownStore,
			addressValidationResponse,
		},
	},
}) => {
	return (
		<div>
			<div>
				<div className="ReactModal__header">
					<h3 className="spc--bottom--sml">{translate('FULFILLMENTORDER.EDITMODAL.ADDRESSVALIDATION')}</h3>
				</div>
				<div className="ReactModal__body">
					<ButtonGroup className="k-button-group--validation">
						<Button togglable={true} selected={useEnteredAddress} onClick={() => onToggleAddress(true)} type="button">
							<div>
								<h6>{translate('FULFILLMENTORDER.EDITMODAL.ENTEREDADDRESS')}</h6>
								{addressValidationResponse.enteredAddress.streetLines.map((streetLine, index) => {
									return streetLine ? <p key={index}>{streetLine}</p> : null;
								})}
								<p>{addressValidationResponse.enteredAddress.city}</p>
								<p>
									{addressValidationResponse.enteredAddress.postalCode}{' '}
									{stateDropdownStore.value ? stateDropdownStore.value.label : ''}
								</p>
								<p>{countryDropdownStore.value ? countryDropdownStore.value.label : ''}</p>
							</div>
							<BasicRadio
								value={useEnteredAddress}
								name="useEnteredAddress"
								label=""
								className="input--radio"
							></BasicRadio>
						</Button>

						<Button togglable={true} selected={!useEnteredAddress} onClick={() => onToggleAddress(false)} type="button">
							<div>
								<h6>{translate('FULFILLMENTORDER.EDITMODAL.UPDATEDADDRESS')}</h6>
								{addressValidationResponse.updatedAddress.streetLines.map((streetLine, index) => {
									return streetLine ? <p key={index}>{streetLine}</p> : null;
								})}
								<p>{addressValidationResponse.updatedAddress.city}</p>
								<p>
									{addressValidationResponse.updatedAddress.postalCode}{' '}
									{stateDropdownStore.value ? stateDropdownStore.value.label : ''}
								</p>
								<p>{countryDropdownStore.value ? countryDropdownStore.value.label : ''}</p>
							</div>
							<BasicRadio
								value={!useEnteredAddress}
								label=""
								name="useUpdatedAddress"
								className="input--radio"
							></BasicRadio>
						</Button>
					</ButtonGroup>
				</div>
			</div>

			<div className="ReactModal__footer">
				<button
					className="btn btn--med btn--primary spc--right--sml spc--bottom--sml"
					type="button"
					onClick={onValidateAddressConfirm}
				>
					{translate('FULFILLMENTORDER.EDITMODAL.CONFIRM')}
				</button>
				<button className="btn btn--med btn--secondary spc--bottom--sml" type="button" onClick={onValidateAddressBack}>
					{translate('FULFILLMENTORDER.EDITMODAL.BACK')}
				</button>
			</div>
		</div>
	);
};

export default defaultTemplate(AddressValidationTemplate);
